module.exports = __webpack_public_path__ + "static/media/HumanTorsos.393dd20e.png";